import { render } from "./HelloWorld.vue?vue&type=template&id=dde8f050&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=dde8f050&lang=scss&scoped=true"

import exportComponent from "/Users/tt/Projects/JavaProjects/xiongmaohaixing/vue_h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dde8f050"]])

export default __exports__